var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhiteLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 231.509,
    height: 48.763,
    viewBox: "0 0 231.509 48.763",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M74.969,0l7.589,9.374h23.224c5.106,0,7.275,4.057,7.345,7.415a6.725,6.725,0,0,1-5.837,6.755H94.4l6.578,8.355h11.588c9.373-3.358,11.262-9.024,11.332-15.389C123.9,7.9,117.6,0,105.782,0Z",
    transform: "translate(-74.969)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M74.292,168.581l20.08,25.22h12.547l-20.08-25.22Z",
    transform: "translate(-74.292 -168.581)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.157,
    y1: 1.194,
    x2: -0.154,
    y2: 1.194,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff8b00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff4e00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M213.666,168.581l20.081,25.22h12.547l-20.08-25.22Z",
    transform: "translate(-213.666 -168.581)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.637,
    y1: 1.194,
    x2: -0.633,
    y2: 1.194,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M478.392,70.678a6.48,6.48,0,0,1-2.42-.705,3.093,3.093,0,0,1-1.341-1.452,7.27,7.27,0,0,1,0-4.84,3.028,3.028,0,0,1,1.341-1.438,6.679,6.679,0,0,1,2.42-.691,37.2,37.2,0,0,1,7.3,0,6.681,6.681,0,0,1,2.42.691,3.03,3.03,0,0,1,1.342,1.438,7.267,7.267,0,0,1,0,4.84,3.1,3.1,0,0,1-1.342,1.452,6.482,6.482,0,0,1-2.42.705,37.2,37.2,0,0,1-7.3,0m-6.5-11.824q-3.374,2.3-3.374,7.246,0,4.978,3.361,7.274t10.164,2.3q6.775,0,10.15-2.3t3.374-7.274q0-4.951-3.388-7.246t-10.136-2.3q-6.777,0-10.151,2.3",
    transform: "translate(-468.519 -56.559)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M659.5,57.2a6.405,6.405,0,0,0-1.466,1.438L646.166,75.366h6.776l8.685-12.28,3.319,4.9q.47.663.982,1.424t.9,1.258q-.664-.055-1.563-.055h-6.375l-3.457,4.757h21.517L665.388,58.633a5.655,5.655,0,0,0-1.479-1.48,4.262,4.262,0,0,0-4.412.042",
    transform: "translate(-646.166 -56.559)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -2.931,
    y1: 2.887,
    x2: -2.927,
    y2: 2.887,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    "data-name": "Path 10",
    d: "M878.954,58.737,875.3,63.55h12.391a6.539,6.539,0,0,1,2.157.346,5.863,5.863,0,0,1,1.742.94,4.215,4.215,0,0,1,1.161,1.424,4.132,4.132,0,0,1,0,3.609,4.251,4.251,0,0,1-1.134,1.4,5.209,5.209,0,0,1-1.728.9,7.278,7.278,0,0,1-2.2.318h-6.638V65.707H875.3V77.24h12.391a13.335,13.335,0,0,0,4.453-.719,11.007,11.007,0,0,0,3.527-1.977A9.168,9.168,0,0,0,898,71.556a8.433,8.433,0,0,0,.843-3.748,8.136,8.136,0,0,0-.829-3.665,8.594,8.594,0,0,0-2.31-2.877,10.813,10.813,0,0,0-3.526-1.867,14.465,14.465,0,0,0-4.481-.664Z",
    transform: "translate(-875.303 -58.737)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1059.57,58.737a13.735,13.735,0,0,0-3.609.415,6.944,6.944,0,0,0-2.461,1.161,4.557,4.557,0,0,0-1.411,1.812,5.939,5.939,0,0,0-.456,2.364,5.519,5.519,0,0,0,.415,2.171,4.244,4.244,0,0,0,1.272,1.674,6.223,6.223,0,0,0,2.157,1.079,10.916,10.916,0,0,0,3.1.387h10.068a2.829,2.829,0,0,1,1.493.3,1.126,1.126,0,0,1,.47,1.023,1.16,1.16,0,0,1-.47,1.037,2.722,2.722,0,0,1-1.493.318h-14l-3.678,4.757H1068.2a13.739,13.739,0,0,0,3.609-.415,6.813,6.813,0,0,0,2.475-1.189,4.507,4.507,0,0,0,1.411-1.908,6.957,6.957,0,0,0,.443-2.545,4.358,4.358,0,0,0-1.77-3.8,8.887,8.887,0,0,0-5.172-1.259h-10.068a2.948,2.948,0,0,1-1.479-.29,1.079,1.079,0,0,1-.484-1.009,1.048,1.048,0,0,1,.484-1,3.074,3.074,0,0,1,1.479-.276h12.833l3.679-4.813Z",
    transform: "translate(-1050.968 -58.737)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 5.725,
    height: 18.503,
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1308.313,58.737l-3.651,4.813h12.391a6.539,6.539,0,0,1,2.157.346,5.864,5.864,0,0,1,1.743.94,4.22,4.22,0,0,1,1.161,1.424,4.132,4.132,0,0,1,0,3.609,4.254,4.254,0,0,1-1.134,1.4,5.209,5.209,0,0,1-1.729.9,7.277,7.277,0,0,1-2.2.318h-6.638V65.707h-5.753V77.24h12.391a13.334,13.334,0,0,0,4.453-.719,11.008,11.008,0,0,0,3.527-1.977,9.168,9.168,0,0,0,2.323-2.987,8.423,8.423,0,0,0,.844-3.7v-.093a8.124,8.124,0,0,0-.829-3.618,8.6,8.6,0,0,0-2.31-2.877,10.813,10.813,0,0,0-3.526-1.867,14.462,14.462,0,0,0-4.48-.664Z",
    transform: "translate(-1304.662 -58.737)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1488.051,58.737v18.5h17.812l3.678-4.757H1493.8V69.966h11.367l3.291-4.2H1493.8V63.55h11.976l3.706-4.813Z",
    transform: "translate(-1488.051 -58.737)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M477.429,214.5V233h17.812l3.678-4.757H483.182V225.73h11.367l3.291-4.2H483.182v-2.213h11.976l3.706-4.813Z",
    transform: "translate(-477.429 -214.501)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M640.3,214.5a13.741,13.741,0,0,0-3.609.415,6.944,6.944,0,0,0-2.461,1.161,4.558,4.558,0,0,0-1.411,1.812,5.941,5.941,0,0,0-.456,2.364,5.524,5.524,0,0,0,.415,2.171,4.248,4.248,0,0,0,1.272,1.674,6.217,6.217,0,0,0,2.157,1.078,10.918,10.918,0,0,0,3.1.387h10.067a2.83,2.83,0,0,1,1.493.3,1.127,1.127,0,0,1,.47,1.023,1.161,1.161,0,0,1-.47,1.037,2.721,2.721,0,0,1-1.493.318h-14L631.7,233h17.231a13.738,13.738,0,0,0,3.609-.415,6.809,6.809,0,0,0,2.475-1.189,4.5,4.5,0,0,0,1.41-1.908,6.957,6.957,0,0,0,.443-2.545,4.357,4.357,0,0,0-1.77-3.8,8.884,8.884,0,0,0-5.172-1.259H639.86a2.949,2.949,0,0,1-1.479-.29,1.079,1.079,0,0,1-.484-1.01,1.047,1.047,0,0,1,.484-1,3.073,3.073,0,0,1,1.479-.277h12.833l3.679-4.813Z",
    transform: "translate(-631.701 -214.501)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M827.593,214.5l-3.789,4.813h15.931a3.3,3.3,0,0,1,2.06.567,1.839,1.839,0,0,1,.733,1.535,1.877,1.877,0,0,1-.733,1.549,3.243,3.243,0,0,1-2.06.581H823.8V233h5.7v-4.729h9.68a13.59,13.59,0,0,0,3.844-.5,8.891,8.891,0,0,0,2.863-1.383,5.845,5.845,0,0,0,1.784-2.143,6.374,6.374,0,0,0,.608-2.807,6.468,6.468,0,0,0-.608-2.821,6.116,6.116,0,0,0-1.77-2.185,8.61,8.61,0,0,0-2.849-1.424,13.257,13.257,0,0,0-3.844-.512Z",
    transform: "translate(-823.804 -214.501)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1019.644,226.443a6.483,6.483,0,0,1-2.42-.705,3.092,3.092,0,0,1-1.341-1.452,7.271,7.271,0,0,1,0-4.84,3.027,3.027,0,0,1,1.341-1.438,6.677,6.677,0,0,1,2.42-.691,37.166,37.166,0,0,1,7.3,0,6.678,6.678,0,0,1,2.42.691,3.028,3.028,0,0,1,1.342,1.438,7.267,7.267,0,0,1,0,4.84,3.094,3.094,0,0,1-1.342,1.452,6.484,6.484,0,0,1-2.42.705,37.169,37.169,0,0,1-7.3,0m-6.5-11.824q-3.375,2.3-3.374,7.247,0,4.978,3.36,7.274t10.164,2.3q6.775,0,10.15-2.3,3.354-2.282,3.375-7.217v-.114q-.019-4.907-3.388-7.19-3.389-2.295-10.136-2.3-6.777,0-10.151,2.3",
    transform: "translate(-1009.771 -212.324)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1219.666,212.518a2.65,2.65,0,0,0-1,.608,3.025,3.025,0,0,0-.691,1.079,4.273,4.273,0,0,0-.263,1.577v15.35h5.2V220.262l11.339,10.178a2.982,2.982,0,0,0,2.3,1,3.748,3.748,0,0,0,1.19-.194,2.538,2.538,0,0,0,1.009-.622,3.178,3.178,0,0,0,.692-1.092,4.279,4.279,0,0,0,.262-1.576V212.628h-5.227V223.5l-11.34-10.178a3.66,3.66,0,0,0-1.231-.816,3.354,3.354,0,0,0-1.065-.18,3.611,3.611,0,0,0-1.175.194",
    transform: "translate(-1217.716 -212.324)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1394.258,214.5a13.74,13.74,0,0,0-3.61.415,6.943,6.943,0,0,0-2.461,1.161,4.557,4.557,0,0,0-1.411,1.812,5.943,5.943,0,0,0-.456,2.364,5.521,5.521,0,0,0,.415,2.171,4.244,4.244,0,0,0,1.272,1.674,6.218,6.218,0,0,0,2.157,1.078,10.917,10.917,0,0,0,3.1.387h10.067a2.829,2.829,0,0,1,1.493.3,1.126,1.126,0,0,1,.47,1.023,1.16,1.16,0,0,1-.47,1.037,2.72,2.72,0,0,1-1.493.318h-13.995L1385.656,233h17.231a13.74,13.74,0,0,0,3.61-.415,6.807,6.807,0,0,0,2.475-1.189,4.505,4.505,0,0,0,1.411-1.908,6.959,6.959,0,0,0,.443-2.545,4.357,4.357,0,0,0-1.77-3.8,8.884,8.884,0,0,0-5.172-1.259h-10.067a2.949,2.949,0,0,1-1.48-.29,1.079,1.079,0,0,1-.484-1.01,1.047,1.047,0,0,1,.484-1,3.074,3.074,0,0,1,1.48-.277h12.833l3.678-4.813Z",
    transform: "translate(-1385.656 -214.501)",
    fill: "#fafafa"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1578.156,214.5V233h17.812l3.678-4.757h-15.737V225.73h11.367l3.292-4.2h-14.658v-2.213h11.976l3.706-4.813Z",
    transform: "translate(-1578.156 -214.501)",
    fill: "#fafafa"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo",
    transform: "translate(-74.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(74.387)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_74",
    "data-name": "Group 74",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_71",
    "data-name": "Rectangle 71",
    width: 48.93,
    height: 31.898,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(74.292 23.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_72",
    "data-name": "Rectangle 72",
    width: 40.609,
    height: 37.491,
    transform: "matrix(0.886, -0.465, 0.465, 0.886, -10.375, 5.443)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79",
    transform: "translate(93.756 23.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(0)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_73",
    "data-name": "Rectangle 73",
    width: 40.609,
    height: 37.491,
    transform: "translate(-10.375 5.443) rotate(-27.681)",
    fill: "url(#linear-gradient-2)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(129.347 7.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_74",
    "data-name": "Rectangle 74",
    width: 27.049,
    height: 19.111,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(154.156 7.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_75",
    "data-name": "Rectangle 75",
    width: 30.783,
    height: 18.807,
    transform: "translate(0 0)",
    fill: "url(#linear-gradient-3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_85",
    "data-name": "Group 85",
    transform: "translate(186.156 8.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_76",
    "data-name": "Rectangle 76",
    width: 23.537,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_87",
    "data-name": "Group 87",
    transform: "translate(210.688 8.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_77",
    "data-name": "Rectangle 77",
    width: 25.169,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_89",
    "data-name": "Group 89",
    transform: "translate(237.654 8.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_88",
    "data-name": "Group 88",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 5.725,
    height: 18.503,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_91",
    "data-name": "Group 91",
    transform: "translate(246.117 8.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_90",
    "data-name": "Group 90",
    clipPath: "url(#clip-path-9)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_80",
    "data-name": "Rectangle 80",
    width: 23.536,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(271.728 8.203)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    clipPath: "url(#clip-path-10)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_81",
    "data-name": "Rectangle 81",
    width: 21.49,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(130.591 29.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(0)",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_82",
    "data-name": "Rectangle 82",
    width: 21.49,
    height: 18.503,
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(152.136 29.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    clipPath: "url(#clip-path-12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_83",
    "data-name": "Rectangle 83",
    width: 25.169,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(178.964 29.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_98",
    "data-name": "Group 98",
    transform: "translate(0)",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_84",
    "data-name": "Rectangle 84",
    width: 24.477,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(204.935 29.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(0)",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_85",
    "data-name": "Rectangle 85",
    width: 27.049,
    height: 19.111,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_103",
    "data-name": "Group 103",
    transform: "translate(233.975 29.652)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102",
    "data-name": "Group 102",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_86",
    "data-name": "Rectangle 86",
    width: 21.988,
    height: 19.111,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_105",
    "data-name": "Group 105",
    transform: "translate(257.428 29.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104",
    "data-name": "Group 104",
    clipPath: "url(#clip-path-16)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_87",
    "data-name": "Rectangle 87",
    width: 25.169,
    height: 18.503,
    transform: "translate(0 0)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_107",
    "data-name": "Group 107",
    transform: "translate(284.312 29.956)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_106",
    "data-name": "Group 106",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_88",
    "data-name": "Rectangle 88",
    width: 21.49,
    height: 18.503,
    fill: "#fafafa"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteLogo);
export default __webpack_public_path__ + "static/media/White-logo.7f84e11ce3362cf4e30296971dd4699b.svg";
export { ForwardRef as ReactComponent };